import { cn } from '@/lib/utils';

export interface TabItem<T extends string = string> {
    value: T;
    label: string;
}

interface TabMobileProps<T extends string = string> {
    items: TabItem<T>[];
    value: T;
    onChange: (value: T) => void;
    className?: string;
}

const TabMobile = <T extends string = string>({ items, value, onChange, className }: TabMobileProps<T>) => {
    return (
        <div role="tablist" className={cn('w-full flex border-b border-blue-cs-200', className)}>
            {items.map((item) => {
                const isActive = item.value === value;
                return (
                    <button
                        key={item.value}
                        type="button"
                        role="tab"
                        aria-selected={isActive}
                        onClick={() => onChange(item.value)}
                        className={cn(
                            'flex-1 py-3 text-center title2medium transition-colors -mb-px border-b-2',
                            isActive
                                ? 'text-text-blue-100 border-text-blue-100'
                                : 'text-text-grey border-transparent'
                        )}
                    >
                        {item.label}
                    </button>
                );
            })}
        </div>
    );
};

export default TabMobile;
